import React, { useEffect, useMemo, useRef, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import FooterNew from "../NavBar/FooterNew";
import Nav from "../NavBar/Nav";
import axios from "axios";
import base_url from "../../api/bootapi";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import SearchIcon from "@mui/icons-material/Search";
import { DatePicker } from "@mantine/dates";

import "./flight.css";

import { Menu, Button, Text, Modal } from "@mantine/core";
import debounce from "lodash.debounce";
import { useDisclosure } from "@mantine/hooks";

const FlightItem = ({ flight }) => {
  const getTotalDuration = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return (
      <span className="flight-duration-time">
        {hours}
        <span>h</span> {minutes}
        <span>m</span>
      </span>
    );
  };
  return (
    <div className="flight-item-wrapper">
      <span className="flight-class">{flight.flights[0].travel_class}</span>
      <div className="flight-logo">
        <img
          src={flight.airline_logo}
          alt="Airline Logo"
          className="flight-logo-img"
        />
        <div className="flight-logo-details">
          <span className="flight-logo-name">{flight.flights[0].airplane}</span>
          <span className="flight-logo-code">
            {flight.flights[0].flight_number}
          </span>
        </div>
      </div>

      <div className="flight-destination-wrapper">
        <div className="flight-from-details">
          <span className="mobile-flight-from-airport">
            {" "}
            {flight.flights[0].departure_airport.id}
          </span>
          <span className="flight-from-time">
            {flight.flights[0].departure_airport.time.split(" ")[1]}
          </span>
          <span className="flight-from-airport">
            {flight.flights[0].departure_airport.name}
          </span>
        </div>

        <div className="flight-duration">
          {getTotalDuration(flight.total_duration)}
          <p></p>
          <span className="flight-duration-label">Duration</span>
        </div>

        <div className="flight-to-details">
          <span className="mobile-flight-from-airport">
            {" "}
            {flight.flights[0].arrival_airport.id}
          </span>

          <span className="flight-from-time">
            {flight.flights[0].arrival_airport.time.split(" ")[1]}
          </span>
          <span className="flight-from-airport" style={{ textAlign: "right" }}>
            {flight.flights[0].arrival_airport.name}
          </span>
        </div>
      </div>

      {flight?.price && (
        <div className="flight-price-details">
          <span className="flight-price">${flight.price}</span>
          <span className="flight-price-label">per adult</span>
        </div>
      )}

      <div className="mobile-flight-details">
        <div
          className="mobile-flight-logo"
          style={{ justifyContent: "flex-start" }}
        >
          <img
            src={flight.airline_logo}
            alt="Airline Logo"
            className="flight-logo-img"
          />

          <span className="flight-logo-name">{flight.flights[0].airplane}</span>
        </div>
        <div className="mobile-flight-class">
          {flight.flights[0].travel_class}
        </div>
        {flight?.price && (
          <div
            className="mobile-flight-price-details"
            style={{ justifyContent: "flex-end" }}
          >
            <span className="flight-price">${flight.price}</span>
          </div>
        )}
      </div>

      {/* <button className="view-fares-btn">View Fares</button> */}
    </div>
  );
};

const Flights = () => {
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [defaultOptions, setDefaultOptions] = useState([]);

  const [fromAirport, setFromAirport] = useState(null);
  const [toAirport, setToAirport] = useState(null);

  const [showFromAirport, setShowFromAirport] = useState(false);
  const [showToAirport, setShowToAirport] = useState(false);
  const [showTravellerClass, setShowTravellerClass] = useState(false);

  const [childern, setChildren] = useState(0);
  const [infants, setInfants] = useState(0);
  const [adults, setAdults] = useState(1);
  const [flightClass, setFlightClass] = useState("Economy");

  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const formattedToday = `${yyyy}-${mm}-${dd}`;
  const [departureDate, setDepartureDate] = useState(formattedToday);
  const [returnDate, setReturnDate] = useState(formattedToday);
  const [showDepartureDate, setShowDepartureDate] = useState(false);
  const [showReturnDate, setShowReturnDate] = useState(false);
  const [tripType, setTripType] = useState("one-way");

  const debouncedLoadOptions = useMemo(
    () =>
      debounce((value, callback) => {
        loadOptions(value, callback);
      }, 300),
    []
  );

  const loadOptions = (inputValue, callback) => {
    fetchAirports(inputValue).then((options) => callback(options));
  };

  const handleExchange = () => {
    const temp = fromAirport;
    setFromAirport(toAirport);
    setToAirport(temp);
  };

  const [flights, setFlights] = useState([]);

  const fetchAirports = async (inputValue) => {
    if (inputValue.length > 0) {
      try {
        const response = await axios.get(
          `${base_url.api1}/tourapp/flight_states_airports?search=${inputValue}&sortby=airport_name`
        );
        if (response.data && response.data.Airports) {
          return response.data.Airports.map((airport) => ({
            value: airport.id,
            label: `${airport.airport_name.replace(
              /[\n\u0000-\u001F\u007F-\u009F]/g,
              ""
            )} (${airport.iata_code})`,
            iata_code: airport.iata_code,
          }));
        }
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    }
    return [];
  };

  const [initialAirports, setInitialAirports] = useState([]);
  const fetchInitialAirports = async () => {
    try {
      const response = await axios.get(
        `${base_url.api1}/tourapp/flight_states_airports?sortby=airport_name`
      );
      if (response.data && response.data.Airports) {
        console.log("Airposrts ===========> ", response.data.Airports);
        const options = response.data.Airports.map((airport) => ({
          value: airport.id,
          label: `${airport.airport_name.replace(
            /[\n\u0000-\u001F\u007F-\u009F]/g,
            ""
          )} (${airport.iata_code})`,
          iata_code: airport.iata_code,
        }));
        setInitialAirports(options);
        setDefaultOptions(options);
      }
    } catch (error) {
      console.error("Error fetching initial airports:", error);
    }
  };

  const searchFromInputRef = useRef(null);
  useEffect(() => {
    if (showFromAirport && searchFromInputRef.current) {
      searchFromInputRef.current.focus();
    }
  }, [showFromAirport]);

  const searchToInputRef = useRef(null);
  useEffect(() => {
    if (showToAirport && searchToInputRef.current) {
      searchToInputRef.current.focus();
    }
  }, [showToAirport]);

  console.log(showToAirport);

  useEffect(() => {
    fetchInitialAirports();
  }, []);

  const [showSearch, setShowSearch] = useState(false);

  useEffect(() => {
    if (fromAirport && toAirport && departureDate) {
      setShowSearch(true);
    }
  }, [fromAirport, toAirport, departureDate]);
  const formatDate = (date) => {
    const options = { day: "2-digit", month: "short", year: "2-digit" };
    return new Date(date).toLocaleDateString("en-GB", options);
  };

  const handleCloseFromAirport = () => {
    setShowFromAirport(false);
    setDefaultOptions(initialAirports);
  };

  const [
    fromAirportOpened,
    { open: fromAirportOpen, close: fromAirportClose },
  ] = useDisclosure(false);
  const [toAirportOpened, { open: toAirportOpen, close: toAirportClose }] =
    useDisclosure(false);
  const [
    departureDateOpened,
    { open: departureDateOpen, close: departureDateClose },
  ] = useDisclosure(false);
  const [returnDateOpened, { open: returnDateOpen, close: returnDateClose }] =
    useDisclosure(false);
  const [
    travelClassOpened,
    { open: travelClassOpen, close: travelClassClose },
  ] = useDisclosure(false);

  const handleCloseToAirport = () => {
    setShowToAirport(false);
    setDefaultOptions(initialAirports);
  };
  const [loading, setLoading] = useState(false);
  const handleSearch = async () => {
    if (!fromAirport || !toAirport || !departureDate) {
      return;
    }
    setLoading(true);
    const requestData = {
      engine: "google_flights",
      departure_id: fromAirport.iata_code,
      arrival_id: toAirport.iata_code,
      outbound_date: departureDate,

      currency: "USD",
      adults: adults,
      children: childern,
      infants_in_seat: 0,
      infants_on_lap: infants,
      type: tripType === "round-trip" ? 1 : 2,
      cabin_class: flightClass,
    };

    if (tripType === "round-trip") {
      requestData.return_date = returnDate;
    }

    try {
      const response = await axios.post(
        `https://apilinsoatours.odisoft.in/users/flight_search`,
        requestData
      );
      console.log(response.data.best_flights);
      const combinedFlights = [
        ...(response.data.best_flights || []),
        ...(response.data.other_flights || []),
      ];
      setFlights(combinedFlights);
      setLoading(false);
      // Handle the response data as needed
    } catch (error) {
      setFlights([]);
      console.error("Error searching flights:", error);
      setLoading(false);
    }
  };
  return (
    <div style={{ backgroundColor: "#F5F6FA" }}>
      <React.Fragment>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={backdropOpen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Nav />
        <div className="search-flight-wrapper">
          <div className="container">
            <div>
              <div className="flight-radio-btns">
                <div className="radio-btn">
                  <input
                    type="radio"
                    id="one-way"
                    name="flight-type"
                    value="one-way"
                    onChange={(e) => setTripType(e.target.value)}
                    checked={tripType === "one-way"}
                  />
                  <label htmlFor="one-way">One Way</label>
                </div>
                <div className="radio-btn">
                  <input
                    type="radio"
                    id="round-trip"
                    name="flight-type"
                    value="round-trip"
                    onChange={(e) => setTripType(e.target.value)}
                    checked={tripType === "round-trip"}
                  />
                  <label htmlFor="round-trip">Round Trip</label>
                </div>
              </div>
              <div>
                <div className="flight-search-inputs">
                  <div className="from-to-wrapper">
                    <Menu
                      shadow="md"
                      opened={showFromAirport}
                      onChange={setShowFromAirport}
                    >
                      <Menu.Target>
                        <div
                          className="flight-input"
                          onClick={() => setShowFromAirport(true)}
                          style={{ width: "250px" }}
                        >
                          <label htmlFor="from-airport">From</label>
                          <span className="flight-input-name">
                            {fromAirport?.label || "Select Airport"}
                          </span>
                        </div>
                      </Menu.Target>

                      <Menu.Dropdown>
                        <div className="flight-input-dropdown">
                          <div className="search-input">
                            <SearchIcon color="#222" />
                            <input
                              type="text"
                              ref={searchFromInputRef}
                              placeholder="Search airports"
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue.length === 0) {
                                  setDefaultOptions(initialAirports);
                                  return;
                                }
                                debouncedLoadOptions(inputValue, (options) => {
                                  setDefaultOptions(options);
                                });
                              }}
                            />
                          </div>

                          <div className="flight-dropdown-list">
                            {defaultOptions.length > 0 ? (
                              defaultOptions.map((option) => (
                                <span
                                  className="flight-dropdown-item"
                                  key={option.value}
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    setFromAirport(option);
                                    console.log(option);
                                    handleCloseFromAirport();
                                  }}
                                >
                                  {option.label}
                                </span>
                              ))
                            ) : (
                              <span
                                style={{
                                  padding: "10px",
                                  display: "block",
                                  textAlign: "center",
                                }}
                              >
                                No airports found
                              </span>
                            )}
                          </div>
                        </div>
                      </Menu.Dropdown>
                    </Menu>

                    <div
                      className="flight-input swap"
                      style={{
                        justifyContent: "center",
                        width: "75px",
                        flex: "initial",
                        padding: "20px",
                      }}
                      onClick={handleExchange}
                    >
                      <SwapHorizIcon fontSize="large" />
                    </div>

                    <Menu
                      shadow="md"
                      opened={showToAirport}
                      onChange={setShowToAirport}
                    >
                      <Menu.Target>
                        <div
                          className="flight-input"
                          style={{ width: "250px" }}
                        >
                          <label htmlFor="to-airport">To</label>
                          <span className="flight-input-name">
                            {toAirport?.label || "Select Airport"}
                          </span>
                        </div>
                      </Menu.Target>
                      <Menu.Dropdown>
                        <div className="flight-input-dropdown">
                          <div className="search-input">
                            <SearchIcon />
                            <input
                              type="text"
                              placeholder="Search airports"
                              ref={searchToInputRef}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue.length === 0) {
                                  setDefaultOptions(initialAirports);
                                  return;
                                }
                                debouncedLoadOptions(inputValue, (options) => {
                                  setDefaultOptions(options);
                                });
                              }}
                            />
                          </div>

                          <div className="flight-dropdown-list">
                            {defaultOptions.length > 0 ? (
                              defaultOptions.map((option) => (
                                <span
                                  key={option.value}
                                  className="flight-dropdown-item"
                                  onClick={(e) => {
                                    e.stopPropagation();

                                    setToAirport(option);
                                    console.log(option);
                                    handleCloseToAirport();
                                  }}
                                >
                                  {option.label}
                                </span>
                              ))
                            ) : (
                              <span
                                style={{
                                  padding: "10px",
                                  display: "block",
                                  textAlign: "center",
                                }}
                              >
                                No airports found
                              </span>
                            )}
                          </div>
                        </div>
                      </Menu.Dropdown>
                    </Menu>
                  </div>

                  <div className="dates-wrapper">
                    <Menu
                      shadow="md"
                      opened={showDepartureDate}
                      onChange={setShowDepartureDate}
                    >
                      <Menu.Target>
                        <div className="flight-input flight-date-input">
                          <label htmlFor="departure-date">Departure</label>
                          <span className="flight-input-name">
                            {formatDate(departureDate)}
                          </span>
                        </div>
                      </Menu.Target>

                      <Menu.Dropdown>
                        <div
                          className="flight-input-dropdown"
                          style={{ width: "fit-content" }}
                        >
                          <DatePicker
                            value={departureDate}
                            onChange={(setDate) => {
                              setDepartureDate(setDate);
                              setShowDepartureDate(false);
                            }}
                          />
                        </div>
                      </Menu.Dropdown>
                    </Menu>

                    <Menu
                      shadow="md"
                      opened={showReturnDate}
                      onChange={setShowReturnDate}
                      disabled={tripType === "one-way" ? true : false}
                    >
                      <Menu.Target>
                        <div
                          className="flight-input flight-date-input"
                          style={{ opacity: tripType === "one-way" ? 0.5 : 1 }}
                        >
                          <label htmlFor="return-date">Return</label>
                          {tripType === "one-way" ? (
                            <span className="flight-input-name">-</span>
                          ) : (
                            <span className="flight-input-name">
                              {returnDate
                                ? formatDate(returnDate)
                                : "Select return date"}
                            </span>
                          )}
                        </div>
                      </Menu.Target>
                      <Menu.Dropdown>
                        <div
                          className="flight-input-dropdown"
                          style={{ width: "fit-content" }}
                        >
                          <DatePicker
                            value={returnDate}
                            onChange={(setDate) => {
                              setReturnDate(setDate);
                              setShowReturnDate(false);
                            }}
                            placeholder="Select return date"
                          />
                        </div>
                      </Menu.Dropdown>
                    </Menu>
                  </div>

                  <Menu
                    shadow="md"
                    opened={showTravellerClass}
                    onChange={setShowTravellerClass}
                  >
                    <Menu.Target>
                      <div className="flight-input" style={{ width: "250px" }}>
                        <label htmlFor="return-date">Travellers & Class</label>
                        <span className="flight-input-name">
                          {childern + adults + infants} traveler, {flightClass}
                        </span>
                      </div>
                    </Menu.Target>

                    <Menu.Dropdown>
                      <div className="flight-input-dropdown traveller-dropdown ">
                        <div className="traveller-count-wrapper">
                          <div className="traveller-count">
                            <div className="traveller-label-wrapper">
                              <span className="traveller-label">Adults</span>
                              <span className="traveller-sub-label">
                                (Aged 12+ yrs)
                              </span>
                            </div>

                            <div className="traveller-input">
                              <button
                                className="traveller-input-btn"
                                onClick={() => {
                                  if (adults > 1) {
                                    setAdults(adults - 1);
                                  }
                                }}
                              >
                                -
                              </button>
                              <input
                                type="text"
                                disabled
                                min="1"
                                value={adults}
                                className="traveller-input-field"
                              />
                              <button
                                className="traveller-input-btn"
                                onClick={() => {
                                  setAdults(adults + 1);
                                }}
                              >
                                +
                              </button>
                            </div>
                          </div>

                          <div className="traveller-count">
                            <div className="traveller-label-wrapper">
                              <span className="traveller-label">Children</span>
                              <span className="traveller-sub-label">
                                (Aged 2-12 yrs)
                              </span>
                            </div>

                            <div className="traveller-input">
                              <button
                                className="traveller-input-btn"
                                onClick={() => {
                                  if (childern > 0) {
                                    setChildren(childern - 1);
                                  }
                                }}
                              >
                                -
                              </button>
                              <input
                                type="text"
                                disabled
                                min="1"
                                value={childern}
                                className="traveller-input-field"
                              />
                              <button
                                className="traveller-input-btn"
                                onClick={() => {
                                  setChildren(childern + 1);
                                }}
                              >
                                +
                              </button>
                            </div>
                          </div>

                          <div className="traveller-count">
                            <div className="traveller-label-wrapper">
                              <span className="traveller-label">Infants</span>
                              <span className="traveller-sub-label">
                                (Below 2 yrs)
                              </span>
                            </div>

                            <div className="traveller-input">
                              <button
                                className="traveller-input-btn"
                                onClick={() => {
                                  if (infants > 0) {
                                    setInfants(infants - 1);
                                  }
                                }}
                              >
                                -
                              </button>
                              <input
                                type="text"
                                disabled
                                min="1"
                                value={infants}
                                className="traveller-input-field"
                              />
                              <button
                                className="traveller-input-btn"
                                onClick={() => {
                                  setInfants(infants + 1);
                                }}
                              >
                                +
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="traveller-class-wrapper">
                          <h4>Travel Class</h4>

                          <div className="traveller-class-option-wrapper">
                            <span
                              className={
                                flightClass === "Economy"
                                  ? "traveller-class-option active-class"
                                  : "traveller-class-option"
                              }
                              onClick={() => {
                                setFlightClass("Economy");
                              }}
                            >
                              Economy
                            </span>

                            <span
                              className={
                                flightClass === "Premium Economy"
                                  ? "traveller-class-option active-class"
                                  : "traveller-class-option"
                              }
                              onClick={() => {
                                setFlightClass("Premium Economy");
                              }}
                            >
                              Premium Economy
                            </span>

                            <span
                              className={
                                flightClass === "Bussiness"
                                  ? "traveller-class-option active-class"
                                  : "traveller-class-option"
                              }
                              onClick={() => {
                                setFlightClass("Bussiness");
                              }}
                            >
                              Bussiness
                            </span>

                            <span
                              className={
                                flightClass === "First"
                                  ? "traveller-class-option active-class"
                                  : "traveller-class-option"
                              }
                              onClick={() => {
                                setFlightClass("First");
                              }}
                            >
                              First
                            </span>
                          </div>
                        </div>
                      </div>
                    </Menu.Dropdown>
                  </Menu>
                  <button
                    className="search-btn"
                    style={{ opacity: !showSearch ? 0.5 : 1 }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          opened={fromAirportOpened}
          onClose={fromAirportClose}
          centered
          withCloseButton={false}
          size={"auto"}
        >
          <div className="flight-input-dropdown">
            <div className="search-input">
              <SearchIcon color="#222" />
              <input
                type="text"
                ref={searchFromInputRef}
                placeholder="Search airports"
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (inputValue.length === 0) {
                    setDefaultOptions(initialAirports);
                    return;
                  }
                  debouncedLoadOptions(inputValue, (options) => {
                    setDefaultOptions(options);
                  });
                }}
              />
            </div>

            <div className="flight-dropdown-list">
              {defaultOptions.length > 0 ? (
                defaultOptions.map((option) => (
                  <span
                    className="flight-dropdown-item"
                    key={option.value}
                    onClick={(e) => {
                      e.stopPropagation();

                      setFromAirport(option);
                      fromAirportClose();
                    }}
                  >
                    {option.label}
                  </span>
                ))
              ) : (
                <span
                  style={{
                    padding: "10px",
                    display: "block",
                    textAlign: "center",
                  }}
                >
                  No airports found
                </span>
              )}
            </div>
          </div>
        </Modal>

        <Modal
          opened={departureDateOpened}
          onClose={departureDateClose}
          centered
          withCloseButton={false}
          size={"auto"}
        >
          <div
            className="flight-input-dropdown"
            style={{ width: "fit-content" }}
          >
            <DatePicker
              value={departureDate}
              onChange={(setDate) => {
                setDepartureDate(setDate);
                departureDateClose();
              }}
            />
          </div>
        </Modal>

        <Modal
          opened={returnDateOpened}
          onClose={returnDateClose}
          centered
          withCloseButton={false}
          size={"auto"}
        >
          <div
            className="flight-input-dropdown"
            style={{ width: "fit-content" }}
          >
            <DatePicker
              value={returnDate}
              onChange={(setDate) => {
                setReturnDate(setDate);
                returnDateClose();
              }}
              placeholder="Select return date"
            />
          </div>
        </Modal>

        <Modal
          opened={travelClassOpened}
          onClose={travelClassClose}
          centered
          withCloseButton={false}
          size={"auto"}
        >
          <div className="flight-input-dropdown traveller-dropdown ">
            <div className="traveller-count-wrapper">
              <div className="traveller-count">
                <div className="traveller-label-wrapper">
                  <span className="traveller-label">Adults</span>
                  <span className="traveller-sub-label">(Aged 12+ yrs)</span>
                </div>

                <div className="traveller-input">
                  <button
                    className="traveller-input-btn"
                    onClick={() => {
                      if (adults > 1) {
                        setAdults(adults - 1);
                      }
                    }}
                  >
                    -
                  </button>
                  <input
                    type="text"
                    disabled
                    min="1"
                    value={adults}
                    className="traveller-input-field"
                  />
                  <button
                    className="traveller-input-btn"
                    onClick={() => {
                      setAdults(adults + 1);
                    }}
                  >
                    +
                  </button>
                </div>
              </div>

              <div className="traveller-count">
                <div className="traveller-label-wrapper">
                  <span className="traveller-label">Children</span>
                  <span className="traveller-sub-label">(Aged 2-12 yrs)</span>
                </div>

                <div className="traveller-input">
                  <button
                    className="traveller-input-btn"
                    onClick={() => {
                      if (childern > 0) {
                        setChildren(childern - 1);
                      }
                    }}
                  >
                    -
                  </button>
                  <input
                    type="text"
                    disabled
                    min="1"
                    value={childern}
                    className="traveller-input-field"
                  />
                  <button
                    className="traveller-input-btn"
                    onClick={() => {
                      setChildren(childern + 1);
                    }}
                  >
                    +
                  </button>
                </div>
              </div>

              <div className="traveller-count">
                <div className="traveller-label-wrapper">
                  <span className="traveller-label">Infants</span>
                  <span className="traveller-sub-label">(Below 2 yrs)</span>
                </div>

                <div className="traveller-input">
                  <button
                    className="traveller-input-btn"
                    onClick={() => {
                      if (infants > 0) {
                        setInfants(infants - 1);
                      }
                    }}
                  >
                    -
                  </button>
                  <input
                    type="text"
                    disabled
                    min="1"
                    value={infants}
                    className="traveller-input-field"
                  />
                  <button
                    className="traveller-input-btn"
                    onClick={() => {
                      setInfants(infants + 1);
                    }}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>

            <div className="traveller-class-wrapper">
              <h4>Travel Class</h4>

              <div className="traveller-class-option-wrapper">
                <span
                  className={
                    flightClass === "Economy"
                      ? "traveller-class-option active-class"
                      : "traveller-class-option"
                  }
                  onClick={() => {
                    setFlightClass("Economy");
                  }}
                >
                  Economy
                </span>

                <span
                  className={
                    flightClass === "Premium Economy"
                      ? "traveller-class-option active-class"
                      : "traveller-class-option"
                  }
                  onClick={() => {
                    setFlightClass("Premium Economy");
                  }}
                >
                  Premium Economy
                </span>

                <span
                  className={
                    flightClass === "Bussiness"
                      ? "traveller-class-option active-class"
                      : "traveller-class-option"
                  }
                  onClick={() => {
                    setFlightClass("Bussiness");
                  }}
                >
                  Bussiness
                </span>

                <span
                  className={
                    flightClass === "First"
                      ? "traveller-class-option active-class"
                      : "traveller-class-option"
                  }
                  onClick={() => {
                    setFlightClass("First");
                  }}
                >
                  First
                </span>
              </div>
            </div>
          </div>
          <div>
            <button className="search-btn" onClick={travelClassClose}>
              Done
            </button>
          </div>
        </Modal>

        <Modal
          opened={toAirportOpened}
          centered
          withCloseButton={false}
          size={"auto"}
          onClose={toAirportClose}
        >
          <div className="flight-input-dropdown">
            <div className="search-input">
              <SearchIcon color="#222" />
              <input
                type="text"
                ref={searchFromInputRef}
                placeholder="Search airports"
                onChange={(e) => {
                  const inputValue = e.target.value;
                  if (inputValue.length === 0) {
                    setDefaultOptions(initialAirports);
                    return;
                  }
                  debouncedLoadOptions(inputValue, (options) => {
                    setDefaultOptions(options);
                  });
                }}
              />
            </div>

            <div className="flight-dropdown-list">
              {defaultOptions.length > 0 ? (
                defaultOptions.map((option) => (
                  <span
                    className="flight-dropdown-item"
                    key={option.value}
                    onClick={(e) => {
                      e.stopPropagation();

                      setToAirport(option);
                      toAirportClose();
                    }}
                  >
                    {option.label}
                  </span>
                ))
              ) : (
                <span
                  style={{
                    padding: "10px",
                    display: "block",
                    textAlign: "center",
                  }}
                >
                  No airports found
                </span>
              )}
            </div>
          </div>
        </Modal>
        <div className="mobile-search-flight-wrapper">
          <div
            className="mobile-flight-radio-btns"
            style={{ justifyContent: "center", marginBottom: "0px" }}
          >
            <div
              className="mobile-radio-btn"
              style={{ flex: "initial", background: "transparent" }}
            >
              <input
                type="radio"
                id="one-way-mobile"
                name="flight-type-mobile"
                value="one-way"
                onChange={(e) => setTripType(e.target.value)}
                checked={tripType === "one-way"}
                defaultChecked
              />
              <label htmlFor="one-way-mobile" style={{ color: "#222" }}>
                One Way
              </label>
            </div>
            <div
              className="mobile-radio-btn"
              style={{ flex: "initial", background: "transparent" }}
            >
              <input
                type="radio"
                id="round-trip-mobile"
                name="flight-type-mobile"
                value="round-trip"
                onChange={(e) => setTripType(e.target.value)}
                checked={tripType === "round-trip"}
              />
              <label htmlFor="round-trip-mobile" style={{ color: "#222" }}>
                Round Trip
              </label>
            </div>
          </div>

          <div className="mobile-destination">
            <span className="mobile-exchange" onClick={handleExchange}>
              <svg
                width="15px"
                height="15px"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path
                    stroke="#222222"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 20V8m0 12l-3.5-3.5M17 20l3.5-3.5M7 17V4m0 0L3.5 7.5M7 4l3.5 3.5"
                  ></path>{" "}
                </g>
              </svg>
            </span>
            <span className="mobile-input-field" onClick={fromAirportOpen}>
              {" "}
              {fromAirport?.label || "Select Airport"}
            </span>
            <span className="mobile-input-field" onClick={toAirportOpen}>
              {toAirport?.label || "Select Airport"}
            </span>
          </div>

          <div style={{ display: "flex", gap: "5px" }}>
            <span
              className="mobile-input-field"
              onClick={departureDateOpen}
              style={{ flex: 1 }}
            >
              {formatDate(departureDate)}
            </span>

            <span
              className="mobile-input-field"
              onClick={() => {
                if (tripType === "one-way") {
                  return;
                }
                returnDateOpen();
              }}
              style={{ opacity: tripType === "one-way" ? 0.5 : 1, flex: 1 }}
            >
              {tripType === "one-way"
                ? "-"
                : returnDate
                ? formatDate(returnDate)
                : "Select return date"}
            </span>
          </div>

          <span className="mobile-input-field" onClick={travelClassOpen}>
            {childern + adults + infants} traveler, {flightClass}
          </span>

          <button
            style={{
              background: "#1c4b88",
              padding: "10px",
              width: "100%",
              borderRadius: "4px",
              opacity: !showSearch ? 0.5 : 1,
            }}
            onClick={handleSearch}
          >
            Search
          </button>
        </div>

        <div className="flight-list-wrapper">
          {flights.length > 0 &&
            !loading &&
            flights.map((flight, index) => {
              return <FlightItem flight={flight} key={index} />;
            })}

          {flights.length === 0 && !loading && (
            <div className="loader-wrapper">No Flights Found</div>
          )}

          {loading && (
            <div className="loader-wrapper">
              <CircularProgress />
            </div>
          )}
        </div>

        <FooterNew />
      </React.Fragment>
    </div>
  );
};

export default Flights;
